<template>
  <div v-if="!isConfigConnectAuthorizationPartner" class="auth-page" id="formLogin">
    <div class="auth-page__inner">
      <div class="auth-page__brand">
        <div class="auth-page__brand-bg"></div>
        <div class="auth-page__brand-pattern"></div>
        <div class="auth-page__brand-content">
          <h1 class="auth-page__brand-title">Hệ thống quản lý truyền thanh cơ sở</h1>
          <p class="auth-page__brand-desc">Đăng nhập để sử dụng đầy đủ tính năng quản lý thiết bị, phát thanh và theo dõi hoạt động.</p>
          <ul class="auth-page__brand-features">
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-bullhorn"></i></span>
              <span><strong>Phát thanh tập trung</strong> Điều khiển và phát nội dung tới nhiều thiết bị truyền thanh từ một giao diện.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-desktop"></i></span>
              <span><strong>Quản lý thiết bị</strong> Theo dõi trạng thái, cấu hình và khởi động lại thiết bị từ xa.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-map-marker"></i></span>
              <span><strong>Theo dõi theo địa bàn</strong> Quản lý theo đơn vị hành chính, dễ dàng phân quyền theo khu vực.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-headphones"></i></span>
              <span><strong>Phát trực tiếp & ghi âm</strong> Hỗ trợ phát thanh trực tiếp từ micro và ghi âm nội dung phát.</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="auth-page__form-side">
        <div class="auth-page__form-side-pattern" aria-hidden="true"></div>
        <div class="auth-page__wrap">
          <CCard no-body class="auth-page__card">
            <CCardBody class="auth-page__card-body">
              <CForm id="form-login" class="auth-page__form">
                <h2 class="auth-page__title form-fade-in-top">Đăng nhập</h2>
                <p class="auth-page__subtitle">Nhập tài khoản và mật khẩu của bạn</p>
                <div class="form-fade-in-bottom">
              <div class="mb-4">
                <BaseInput
                  :listener="userNameInput.listener"
                  :options="userNameInput.options"
                  :data="userNameInput.data"
                  class="input-wrapper"
                />
              </div>
              <div class="mb-2">
                <BaseInput
                  :options="passWordInput.options"
                  :listener="passWordInput.listener"
                  :data="passWordInput.data"
                  class="input-wrapper"
                />
              </div>
              <template v-if="isVerifyRecaptcha == true">
                <div class="mb-2" id="g-recaptcha"></div>
                <div
                  class="valid-error"
                  v-show="!(recaptchaInput.data.validator ? recaptchaInput.data.validator.isValid : true)"
                >
                  {{ recaptchaInput.data.validator ? recaptchaInput.data.validator.errorMessage : "" }}
                </div>
              </template>
              <div class="auth-page__btn-row">
                <button
                  type="button"
                  class="auth-btn-primary ripple btn-primary"
                  @click="submitLogin()"
                  id="login"
                >
                  Đăng nhập
                  <div class="ripple-effect" hidden></div>
                </button>
                <a href="#" class="auth-link" @click.prevent="submitForgotPassword()">Quên mật khẩu</a>
              </div>
              <div v-if="hasHotline" class="auth-footer">Hỗ trợ: {{ HOTLINE }}</div>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </div>
      </div>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
import BaseLoading from "../base/BaseFormLoading";
import BaseInput from "../base/BaseInput";

import { authLogin, authLoginBySSO } from "@/security/index";
import {
  CLIENT_ID,
  CLIENT_ID_NAME,
  CONFIG_AUTHORIZATION_CONNECT_PARTNER,
  IS_VERIFY_OTP_WITH_MAIL,
  IS_VERIFY_RECAPTCHA,
  TIME_OTP_EXPIRED,
  USER_NAME,
  HOTLINE
} from "@/constant";

export default {
  name: "Login",
  components: { BaseInput, BaseLoading },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted: function () {
    if (!CONFIG_AUTHORIZATION_CONNECT_PARTNER) {
      let that = this;
      setTimeout(function () {
        that.setUpRippleButton();
      }, 500);
      this.checkTimeExpOTP();
      if (this.isVerifyRecaptcha == true) {
        this.initReCaptcha();
      }
    }
  },
  created: function () {
    if (CONFIG_AUTHORIZATION_CONNECT_PARTNER) {
      if (this.$route.query && this.$route.query.code) {
        this.getUserInfoByToken(this.$route.query.code);
      } else {
        window.location.href = this.ssoUrl;
      }
    }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      isConfigConnectAuthorizationPartner: CONFIG_AUTHORIZATION_CONNECT_PARTNER,
      HOTLINE: HOTLINE,
      isVerifyRecaptcha: IS_VERIFY_RECAPTCHA,
      status: true,
      ssoUrl: (this.$route.query && this.$route.query.isLogout == true) ? process.env.SSO_ADDRESS : `${process.env.SSO_ADDRESS}/login.html?redirect-uri=${encodeURIComponent(process.env.URI_REDIRECT)}&client-id=${CLIENT_ID}`,

      clientId: {
        data: {
          name: "client_id",
          model: this.$route.query['client-id'] || CLIENT_ID,
        }
      },
      userNameInput: {
        options: {
          placeholder: "Tài khoản",
          type: "text",
          autocomplete: "off"
        },
        data: {
          name: "username",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.userNameInput.data.model;
              let username_regex = /^([a-zA-Z0-9 !%&@#$^*?_~]){6,}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập không được để trống";
              } else if (username_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage =
                  "Tên đăng nhập ít nhất 6 kí tự và là chữ thường";
              } else if (username_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
        listener: {
          keyup: function (event) {
            if (event.key === "Enter") {
              that.submitLogin();
            }
          }
        }
      },
      passWordInput: {
        options: {
          placeholder: "Mật khẩu",
          type: "password",
          autocomplete: "off"
        },
        data: {
          name: "password",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.passWordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu không được để trống";
              } 
              // else if (password_regex.test(value) == false) {
              //   this.isValid = false;
              //   this.errorMessage = "Mật khẩu sai định dạng";
              // } else if (password_regex.test(value) == true) {
              //   this.isValid = true;
              //   this.errorMessage = "";
              // }
              else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
        listener: {
          keyup: function (event) {
            if (event.key === "Enter") {
              that.submitLogin();
            }
          }
        }
      },
      recaptchaInput: {
        data: {
          model: '',
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = grecaptcha.getResponse();
              if (value === "" || value.length < 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng xác thực captcha";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      }
    };
  },
  computed: {
    hasHotline() {
      const h = this.HOTLINE;
      if (h == null) return false;
      const s = String(h).trim();
      return s.length > 0 && s !== 'undefined';
    }
  },
  watch: {},
  methods: {
    initReCaptcha: function () {
      var self = this;
      setTimeout(function () {
        if (typeof grecaptcha === 'undefined') {
          self.initReCaptcha();
        } else {
          grecaptcha.render('g-recaptcha', {
            'sitekey': process.env.KEY_RECAPTCHA,
            'theme': 'light',
            'type': 'image',
            'data-size': 'compact',
            'expired-callback': function () {
              grecaptcha.reset();
            }
          })
        }
      }, 500);
    },
    interValCountdown() {
      this.otpInterVal = window.setInterval(() => {
        this.now = Math.trunc((new Date()).getTime());
      }, 1000);
    },
    checkTimeExpOTP() {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      if (timeExp && timeExp != undefined) {
        let dateExp = new Date(timeExp * 1);
        if (dateExp <= new Date()) {
          this.disableBtnVerifyOTP = true;
        }
      }
    },
    setUpRippleButton: function () {
      $(".ripple").on("click", function (event) {
        event.preventDefault();
        let $div = $("<div/>"),
          btnOffset = $(this).offset(),
          xPos = event.pageX - btnOffset.left,
          yPos = event.pageY - btnOffset.top;
        $div.addClass("ripple-effect");
        let $ripple = $(".ripple-effect");
        $div
          .css({
            top: yPos - $ripple.height() / 2,
            left: xPos - $ripple.width() / 2
          })
          .appendTo($(this));
        window.setTimeout(function () {
          $div.remove();
        }, 1500);
      });
    },
    submitLogin: function () {
      let that = this;
      let isValid = true;
      isValid &= this.userNameInput.data.validator.valid();
      isValid &= this.passWordInput.data.validator.valid();
      if (this.isVerifyRecaptcha == true) {
        isValid &= this.recaptchaInput.data.validator.valid();
      }
      if (!isValid) {
        return;
      }

      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/login",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            username: btoa(that.userNameInput.data.model),
            password: btoa(that.passWordInput.data.model),
            client_id: btoa(that.clientId.data.model),
          };
        },
        successCallback: function (response) {
          let { data } = response.data;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(data) });
            // grecaptcha.reset();
          } else {
            if (IS_VERIFY_OTP_WITH_MAIL === true) {
              // let clientId = that.$route.query['client-id'];
              // let redirectURI = that.$route.query['redirect-uri'];
              localStorage.setItem(USER_NAME, data.userName);
              localStorage.setItem(TIME_OTP_EXPIRED, data.expireDate);
              localStorage.setItem(CLIENT_ID_NAME, data.clientId);
              // if (that.$route.query && clientId && redirectURI) {
              //   that.$router.push({
              //     path: '/verify.html', query: {'redirect-uri': redirectURI, 'client-id': clientId}
              //   });
              // } else {
              //   that.$router.push({path: '/verify.html'});
              // }
              that.$router.push({ path: '/verify.html' });
              that.showSuccessMsg({ message: "Mã xác thực OTP của đã được gửi về email. Vui lòng kiểm tra email và xác thực người dùng. Xin cảm ơn." })
            } else {
              authLogin(data.access_token, null, data.expires_in, data.authorities, data.username, data.fullName, data.id, JSON.stringify(data.systems), data.lastUpdatePassword);
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitForgotPassword: function () {
      this.$router.push({ path: '/forgot-password.html' });
    },
    getUserInfoByToken: function (auth_code) {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/oauth/user",
        //oauth code
        isRequestBearerToken: false,
        dataSubmit: function () {
          return {
            auth_code: auth_code
          }
        },
        successCallback: function (response) {
          if (response.status === 200) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              that.showErrorMsg({ message: that.$helper.getStringError(dataResponse.data) });
            } else {
              //token
              // authLogin(dataResponse.data.accessToken, dataResponse.data.roles, dataResponse.data.username, dataResponse.data.userId, that.$route.query.exp);
              //oauth code
              authLoginBySSO(dataResponse.data.accessToken, dataResponse.data.roles, dataResponse.data.username, dataResponse.data.userId, dataResponse.data.expires, dataResponse.data.locationCode, dataResponse.data.fullName, dataResponse.data.userPosition);
            }
          } else {
            window.location.href = this.ssoUrl
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  }
};
</script>

<style scoped>
.confirm-otp {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 3px;
}
</style>
